{
  "BUSINESS_NUMBER": {
    "TITLE": "Introduzca su número de expediente para empezar",
    "INSTRUCTION_FORMAT": "Formato: 7 dígitos como mínimo.",
    "PLACEHOLDER": "Ej.: 1234567",
    "ERROR_INVALID_FORMAT": "El número de expediente debe contener al menos 7 dígitos."
  },
  "BUTTON": {
    "VALIDATE": "Validar",
    "VALIDATE_MY_CHOICES": "Validar mis elecciones"
  },
  "CONFIRM_DIALOG": {
    "VALIDATE": "Validar",
    "CANCEL": "Cancelar"
  },
  "FOOTER": {
    "COPYRIGHT_NOTICE": "© {{ year }} EVOQ {{ brandLabel }}. Todos los derechos reservados."
  },
  "FREE_ROAM": {
    "CREATIVE_SUGGESTION": "Para modificar tu escena 3D y obtener una imagen ultrarrealista, podrías considerar añadir elementos específicos como: una estancia anexa, un estilo, elementos de decoración, un momento del día... ¡Deja volar tu creatividad!",
    "TYPE_TEXT_HERE": "Escribe tu texto aquí (mínimo 100 caracteres)",
    "VISUAL_IMPROVEMENT_DESCRIPTION": "Por favor, describe las mejoras que deseas aportar a tu imagen"
  },
  "GENERATION_RESULT": {
    "COPIED_CONFIRMATION": "¡Copiado!",
    "COPY_PROMPT": "Copiar el prompt",
    "ENLARGE_IMAGE": "Ampliar",
    "DOWNLOAD_IMAGE": "Descargar la imagen",
    "DOWNLOAD_VIDEO": "Descargar el vídeo",
    "EDIT_PROMPT": "Editar el prompt",
    "EVOQ_PROPOSED_VISUAL": "Aquí tienes la imagen propuesta por Evoq",
    "EVOQ_PROPOSED_VISUALS": "Aquí tienes las imágenes propuestas por Evoq",
    "GENERATE_VIDEO": "Generar el vídeo",
    "GENERATION_ERROR_RETRY": "Ha ocurrido un error durante la generación. Por favor, inténtalo de nuevo.",
    "SERVER_BUSY_ERROR": "Nuestros servidores están muy ocupados en este momento. Por favor, inténtelo de nuevo en unos instantes.",
    "RETRY_ACTION": "Reintentar",
    "PROCESSING_VIDEOS_COUNT": "{{ processingVideoCount }} vídeos en curso",
    "REGENERATE_ACTION": "Regenerar",
    "REMAINING_IMAGES": "Imágenes restantes:",
    "REMAINING_VIDEOS": "Vídeos restantes:",
    "VIDEO_CREATION_IN_PROGRESS": "Vídeo en proceso de creación",
    "WAIT_MOMENT_MESSAGE": "Por favor, espera un momento..."
  },
  "GUIDED_TOUR": {
    "ANSWER": {
      "ROOM_BATHROOM": "Baño",
      "ROOM_BEDROOM": "Dormitorio",
      "ROOM_DINING": "Comedor",
      "ROOM_DRESSING": "Vestidor",
      "ROOM_ENTRANCE": "Entrada",
      "ROOM_KITCHEN": "Cocina",
      "ROOM_LAUNDRY": "Lavandería",
      "ROOM_LIVING": "Salón",
      "ROOM_NO": "No",
      "ROOM_OFFICE": "Despacho",
      "ROOM_PANTRY": "Despensa",
      "STYLE_CONTEMPORARY": "Contemporáneo",
      "STYLE_COUNTRY": "Campestre",
      "STYLE_COZY": "Acogedor",
      "STYLE_DESIGN": "Diseño",
      "STYLE_HIGH_END": "Alta gama",
      "STYLE_INDUSTRIAL": "Industrial",
      "STYLE_MODERN": "Moderno",
      "STYLE_RUSTIC": "Rústico",
      "STYLE_SCANDINAVIAN": "Escandinavo",
      "STYLE_WOOD": "Madera",
      "TIME_AFTERNOON": "Por la tarde",
      "TIME_EVENING": "Por la noche",
      "TIME_MORNING": "Por la mañana",
      "TIME_NONE": "Ninguno",
      "TIME_NOON": "Al mediodía"
    },
    "FORM": {
      "ENTER_ELEMENT": "Introduce un elemento"
    },
    "QUESTION": {
      "ADJOINING_ROOM": "¿Quieres incluir una estancia anexa en tu plano principal?",
      "APPLY_STYLE": "¿Qué estilo quieres aplicar a tu escena?",
      "DECORATION_ELEMENTS": "¿Qué elementos esenciales de decoración quieres añadir?",
      "MAIN_ROOM_SELECTION": "¿Cuál es la estancia principal sobre la que quieres trabajar?",
      "TIME_OF_DAY": "¿A qué momento del día quieres hacer referencia?"
    }
  },
  "HEADER": {
    "BUDGET_THIS_MONTH": "Presupuesto consumido este mes (estimación)",
    "DASHBOARD": "Panel de control",
    "FREE_CREDITS": "Créditos gratuitos",
    "FREE_CREDITS_LABEL": "créditos gratuitos",
    "IMAGES_THIS_MONTH": "Imágenes generadas este mes",
    "LOGOUT": "Cerrar sesión",
    "NEW_PROJECT": "Nuevo proyecto",
    "THIS_MONTH": "Este mes",
    "VIDEOS_THIS_MONTH": "Vídeos generados este mes"
  },
  "IMAGE_UPLOAD": {
    "ACCEPTED_FORMATS": "Formatos aceptados: PNG o JPEG.",
    "ALL_CREDITS_USED": "Has utilizado todos tus créditos",
    "BLOCKED_GENERIC": "La generación de imágenes no está disponible temporalmente.",
    "BLOCKED_NO_QUOTA": "No hay ninguna cuota de Evoq definida para tu cuenta.",
    "BLOCKED_QUOTA_MONTHLY": "Has agotado tu cuota mensual de Evoq. Ponte en contacto con tu responsable.",
    "BLOCKED_QUOTA_ROLLING": "Has agotado tu cuota de Evoq.",
    "BLOCKED_QUOTA_ROLLING_UNTIL": "Has agotado tu cuota de Evoq. Podrás generar de nuevo el {{ date }}.",
    "BLOCKED_UNAVAILABLE": "No disponible",
    "CATALOG_ONLY_NOTICE": "Nota: Todo elemento presente en tu escena no será transformado por la IA sino mejorado para obtener un resultado realista.",
    "FILE_SIZE_LIMIT": "El tamaño del archivo no debe superar los {{ size }} MB",
    "FREE_IMAGE_GENERATION": "Generación de imagen libre",
    "GUIDED_IMAGE_GENERATION": "Generación de imagen guiada",
    "IMPORT_ROOM_VISUAL": "Importar su imagen",
    "INSUFFICIENT_DIMENSIONS": "Dimensiones insuficientes (mín. {{ minWidth }} x {{ minHeight }} px)",
    "INVALID_FORMAT": "Formato no válido (solo PNG o JPEG)",
    "LIGHTING_WARNING": "<strong>Importante:</strong> utilice un plano sin efectos de iluminación para evitar cualquier alucinación de la IA.",
    "MINIMUM_IMAGE_DIMENSIONS": "Dimensiones mínimas de la imagen a subir: {{ minWidth }} x {{ minHeight }} píxeles.",
    "NO_MORE_CREDIT": "Sin créditos",
    "UNREADABLE_FILE": "No se puede leer el archivo",
    "UPLOAD_ROOM_VISUAL": "Carga la imagen de tu estancia para empezar"
  },
  "LOGIN": {
    "AUTHENTICATING_MESSAGE": "Por favor, espera mientras recuperamos tu información...",
    "AUTHENTICATING_TITLE": "Autenticación en curso",
    "AUTO_LOGIN_FOURNIER": "Conexión automática Fournier",
    "AUTO_LOGIN_FRANCHISEE": "Conexión automática Franquiciado",
    "CHOOSE_SPACE_INSTRUCTION": "Elige tu espacio para continuar",
    "ERROR_FRANCHISE_MISSING_STORE_MESSAGE": "Tu cuenta no está vinculada a ninguna tienda. Por favor, crea un Ticket Easy Vista para completar esta información e inténtalo de nuevo.",
    "ERROR_FRANCHISE_MISSING_STORE_TITLE": "Conexión imposible",
    "ERROR_MESSAGE": "Se ha producido un error al recuperar tu información. Por favor, inténtalo de nuevo.",
    "ERROR_TITLE": "Error de autenticación",
    "RETRY_BUTTON": "Reintentar",
    "WELCOME_MESSAGE": "Bienvenido a Evoq"
  },
  "DASHBOARD": {
    "TITLE": "Dashboard",
    "NAV": {
      "OVERVIEW": "Resumen",
      "VENDORS": "Equipo",
      "BILLING_HISTORY": "Historial de facturación"
    },
    "OVERVIEW": {
      "TITLE": "Resumen",
      "MANAGE": "Gestionar",
      "PLACEHOLDER": {
        "TITLE": "Próximamente",
        "DESCRIPTION": "La vista general de su actividad se está renovando."
      }
    },
    "VENDORS": {
      "TITLE": "Gestión del equipo",
      "PHYSICAL": {
        "SUBTITLE": "Active o dé de baja la suscripción de cada vendedor de su equipo.",
        "COUNTER_ACTIVE": "Suscritos activos",
        "COUNTER_NONE": "Sin suscripción",
        "COUNTER_CANCELLING": "Baja programada",
        "TABLE_TITLE": "Vendedores",
        "COST_HINT": "Coste de la suscripción: {{price}} / mes / vendedor",
        "COST_UNAVAILABLE": "Tarifas no disponibles",
        "COL_VENDOR": "Vendedor",
        "COL_STATUS": "Estado",
        "COL_ACTION": "Acción",
        "SELECT_ALL": "Seleccionar todo",
        "SELECT_ROW": "Seleccionar a {{name}}",
        "SELECT_ROW_DISABLED": "{{name}} no se puede seleccionar",
        "STATUS_SUBSCRIBED": "Suscrito",
        "STATUS_NONE": "Sin suscripción",
        "STATUS_CANCELLING": "Baja programada",
        "CANCELLING_EFFECT": "Efectivo el {{date}}",
        "FREE_CREDITS": "Créditos gratuitos: {{count}} / {{total}} restantes",
        "ACTION_ACTIVATE": "Activar la suscripción",
        "ACTION_CANCEL": "Dar de baja",
        "ACTION_REACTIVATE": "Anular la baja",
        "SELECTED_ONE": "vendedor seleccionado",
        "SELECTED_OTHER": "vendedores seleccionados",
        "BULK_ACTIVATE": "Activar la suscripción",
        "BULK_CLEAR": "Deseleccionar todo",
        "EMPTY": "No hay vendedores en este equipo.",
        "LOADING": "Cargando...",
        "ENGAGEMENT_NOTE": "Suscripción comprometida hasta el final del trimestre natural, renovada automáticamente cada trimestre salvo baja; esta surte efecto al final del trimestre.",
        "CONFIRM_ACTIVATE_TITLE": "Activar la suscripción",
        "CONFIRM_ACTIVATE_BODY": "{{name}}, {{price}} / mes. Suscripción comprometida hasta el final del trimestre natural, luego renovada automáticamente cada trimestre salvo baja.",
        "CONFIRM_ACTIVATE_OK": "Activar",
        "DESK_REQUEST_TITLE": "Para activar una suscripción, abre una solicitud mediante un ticket Desk",
        "DESK_REQUEST_PATH": "Desk → Crear un ticket Desk Fournier Retail, Sección \"Service\"",
        "DESK_CLOSE": "Cerrar",
        "CANCEL": "Cancelar",
        "CONFIRM_CANCEL_TITLE": "Dar de baja la suscripción",
        "CONFIRM_CANCEL_BODY": "Efectivo el {{date}} (final del trimestre en curso). {{name}} conserva el acceso hasta entonces.",
        "CONFIRM_CANCEL_OK": "Dar de baja",
        "CONFIRM_REACTIVATE_TITLE": "Anular la baja",
        "CONFIRM_REACTIVATE_BODY": "La suscripción de {{name}} continuará con normalidad.",
        "CONFIRM_REACTIVATE_OK": "Confirmar",
        "CONFIRM_REACTIVATE_BACK": "Volver",
        "BULK_CONFIRM": "Confirmar la activación",
        "BULK_UNIT_COST": "Coste unitario",
        "BULK_ENGAGEMENT": "Compromiso",
        "BULK_ENGAGEMENT_VALUE": "Hasta el final del trimestre",
        "BULK_TOTAL": "Total mensual",
        "TOAST_ACTIVATED": "Suscripción activada para {{name}}",
        "TOAST_CANCELLED": "Baja programada para {{name}}",
        "TOAST_REACTIVATED": "Baja anulada para {{name}}",
        "TOAST_BULK_ONE": "Suscripción activada para 1 vendedor",
        "TOAST_BULK_OTHER": "Suscripción activada para {{count}} vendedores",
        "TOAST_ERROR": "Se ha producido un error, inténtelo de nuevo."
      }
    },
    "BILLING_HISTORY": {
      "TITLE": "Historial de facturación",
      "BADGE": "suscripciones",
      "INTRO": "Facturación de las suscripciones de tu equipo, facturada mensualmente y agrupada por trimestre. Para cada mes: el número de suscripciones activas y el coste correspondiente.",
      "KPI_TOTAL_YEAR": "Total {{ year }}",
      "KPI_TOTAL_YEAR_TO_DATE": "Total {{ year }} hasta la fecha",
      "KPI_CURRENT_QUARTER": "Trimestre en curso",
      "KPI_LAST_QUARTER": "Último trimestre",
      "CARD_TITLE": "Facturación mensual",
      "YEAR_SELECTOR_LABEL": "Selección del año",
      "STATUS_IN_PROGRESS": "Trimestre en curso",
      "STATUS_CHARGED": "Facturado",
      "SUBTOTAL": "Subtotal",
      "TOTAL": "Total",
      "NOTE": "Factura mensual, emitida por el mes transcurrido y agrupada por trimestre natural (T1 ene.-mar., T2 abr.-jun., T3 jul.-sep., T4 oct.-dic.). Toda suscripción activa en el mes se factura por el mes completo, sin prorrateo. La tarifa y el coste mensual los proporciona la facturación."
    },
    "CONSUMPTION": {
      "TITLE": "Consumo del equipo",
      "VENDOR": "Miembro",
      "IMAGE": "Imagen",
      "VIDEO": "Vídeo",
      "REMAINING": "Resto: {{ value }}",
      "REMAINING_WITH_FREE": "Resto: {{ total }} de los cuales {{ free }} gratuitos",
      "NO_VENDORS": "Ningún miembro por el momento"
    },
    "ALLOCATION": {
      "CANNOT_GENERATE": "No puede generar",
      "QUOTA_HIDDEN_NOTICE": "El cupo lo define aquí el responsable. Para el usuario permanece invisible: el vendedor solo ve su consumo y su presupuesto.",
      "IMAGE_QUOTA": "Cuota Imagen",
      "VIDEO_QUOTA": "Cuota Vídeo",
      "APPLY": "Aplicar",
      "SAVING": "Guardando...",
      "SAVE_QUOTAS": "Guardar las cuotas",
      "SAVE_SUCCESS": "Las cuotas se han actualizado correctamente",
      "IMAGE": "Imagen",
      "VIDEO": "Vídeo",
      "CONSUMPTION": "Consumo",
      "MONTHLY_QUOTA": "Cuota Mensual",
      "FREE_CREDITS": "Gratuitos",
      "REMAINING": "Resto: {{ value }}"
    },
    "PACKS": {
      "FILTER_ALL": "Todos",
      "FILTER_IMAGES": "Imágenes",
      "FILTER_VIDEOS": "Vídeos",
      "FILTER_MIXED": "Mixtos",
      "PRICE_PER_IMAGE": "Es decir {{ price }} por imagen",
      "PRICE_PER_VIDEO": "Es decir {{ price }} por vídeo",
      "CREDITS": "Créditos",
      "IMAGES": "Imágenes",
      "VIDEO": "Vídeo",
      "CHOOSE_PACK": "Elegir este pack"
    },
    "BILLING_HISTORY_TABLE": {
      "MONTH": "Mes",
      "ACTIVE_SUBSCRIPTIONS": "Suscripciones activas",
      "MONTHLY_COST": "Coste mensual",
      "EMPTY_TITLE": "Sin facturación",
      "EMPTY_MESSAGE": "El historial de facturación de tus suscripciones aparecerá aquí."
    },
    "USAGE_HISTORY": {
      "BADGE": "por usuario",
      "INTRO": "Consumo mensual por usuario y coste correspondiente.",
      "KPI_TOTAL_MONTH": "Total",
      "KPI_LAST_3_MONTHS": "Últimos 3 meses",
      "NOTE": "Consumo facturado por trimestre (mes en curso y los dos anteriores). El coste de cada mes se fija en el momento del consumo."
    },
    "USAGE_HISTORY_TABLE": {
      "CARD_TITLE": "Detalle por usuario",
      "USER": "Usuario",
      "IMAGES": "Imágenes",
      "VIDEOS": "Vídeos",
      "COST": "Coste",
      "MONTH_SELECTOR_LABEL": "Selección de mes",
      "TOTAL": "Total",
      "EMPTY_TITLE": "Sin consumo",
      "EMPTY_MESSAGE": "El historial de consumo de su equipo aparecerá aquí."
    }
  },
  "STORE_SELECTION": {
    "TITLE": "Seleccione su tienda",
    "SUBTITLE": "Elija la tienda que desea gestionar",
    "SEARCH_PLACEHOLDER": "Buscar por nombre, ID, marca…",
    "SEARCH_SHORT": "Buscar…",
    "ALL_BRANDS": "Todas las marcas",
    "ALL_TYPES": "Todos los tipos",
    "RESULTS": "resultados",
    "STORES_LINKED": "tiendas vinculadas a su cuenta",
    "NO_RESULTS": "No se encontraron tiendas",
    "SEE_ALL": "Ver todas las tiendas",
    "SWITCH_STORE": "Cambiar de tienda",
    "TYPE": {
      "PHYSICAL": "Física",
      "VIRTUAL": "Virtual"
    },
    "TABLE": {
      "STORE": "Tienda",
      "STORE_ID": "ID Tienda",
      "BRAND": "Marca",
      "TYPE": "Tipo",
      "ACTION": "Acción",
      "SELECT_STORE": "Seleccionar {{ name }}"
    }
  }
}
